export function initCarousel() {
  document.querySelectorAll("[data-carousel]").forEach((root) => {
    const track = root.querySelector("[data-carousel-track]");
    const prev = root.querySelector("[data-carousel-prev]");
    const next = root.querySelector("[data-carousel-next]");
    if (!track || !prev || !next) return;

    const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
    const amount = () => {
      const card = track.querySelector(":scope > *");
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    };

    prev.addEventListener("click", () => {
      track.scrollBy({ left: -amount(), behavior: "smooth" });
    });
    next.addEventListener("click", () => {
      track.scrollBy({ left: amount(), behavior: "smooth" });
    });
  });
}
